import Emitter from "es6-event-emitter";
import template from "./../templates/nextgenReaderComponent.dust";

export default class NextgenReaderComponent extends Emitter {
  static componentName = "NextgenReaderComponent";

  constructor(pubStore, appState, options) {
    super();
    this._pubStore = pubStore;
    this._appState = appState;
    this._options = options;
    this.DOMContainer = document.querySelector("#reader");
    document.documentElement.setAttribute("style", `font-size: 10px;`);
  }

  render() {
    this._appState.on(
      "appState:currentpagechanged",
      this._onCurrentPageChanged
    );

    Dust.render(template, {}, (err, result) => {
      if (err) return;

      this.DOMContainer.innerHTML = result;
      if (window.app) {
        // check if nextgen instance is there
        window.app.initRendering({
          pub: this._pubStore.PublicationToLoad.PublicationID,
          packageId: this._pubStore.CPackage.ContentPackageID,
          appmode: "webappDesktop",
          isPhone: !this._appState.isTablet && !this._appState.isDesktop,
          page: this._appState.currentPage,
          articleId: this._appState.nextgenSharingArticle,
          prefetchPages: true,
          viewerDir: "../NextGenViewer/",
        });
      }

      this.trigger("reader:rendered", "nextgen");
    });
  }

  destroy() {
    window.app.close();
    this._appState.off(
      "appState:currentpagechanged",
      this._onCurrentPageChanged
    );
  }

  ////////////

  _onCurrentPageChanged = (pageIndex) => {
    window.app.state.goToPageIndex(pageIndex);
  };
}



// WEBPACK FOOTER //
// ./src/web/reader/components/nextgenReaderComponent.js